import type {ReactElement} from 'react'
import {useTranslation} from 'react-i18next'

import {useActions} from 'hooks'
import {useMobileViewport} from 'hooks/useMobileViewport'
import {useLocation} from 'react-router'
import {NavLink} from '../LeftNavLink'
import {CanIAccess} from 'rbac'
import {SettingsMobileHome} from 'features/Settings/mobile/SettingsMobileHome'
import {useSettingsMobileEntry} from 'features/Settings/hooks/useSettingsMobileEntry'
import {SETTINGS_NAV_PAGES} from './settingsNavPages'

export function SettingsLeftNavigation(): ReactElement {
  const {t} = useTranslation(['settings'])
  const location = useLocation()
  const {pathname} = location
  const isMobile = useMobileViewport()
  useSettingsMobileEntry(pathname)

  const {doIHaveAccess} = useActions()

  if (isMobile) return <SettingsMobileHome />

  return (
    <div className="flex flex-col items-start pt-3 px-5">
      {SETTINGS_NAV_PAGES.map(page => (
        <CanIAccess key={page.pathname} reqPermissions={[page.permission]}>
          <NavLink
            pathname={page.pathname}
            first
            current={pathname === page.pathname}
            linkName={t(page.labelKey)}
            isVisible={page.adminOnly ? doIHaveAccess : undefined}
          />
        </CanIAccess>
      ))}
    </div>
  )
}
